<template>
  <svg
    width="12"
    height="9"
    viewBox="0 0 12 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.41 0.839996L6 5.42L10.59 0.839996L12 2.25L6 8.25L0 2.25L1.41 0.839996Z"
      fill="black"
      fill-opacity="0.87"
    />
  </svg>
</template>
